import axiosInstance from './rootApi';

/**
 * Generic POST request.
 * @param {string} endpoint - e.g. '/booking'
 * @param {object} data - request body
 * @returns {Promise<any>} - response data
 */
const postApi = async (endpoint, data) => {
  const response = await axiosInstance.post(endpoint, data);
  return response.data;
};

export default postApi;
